<template>
  <v-card>
    <v-form @submit.prevent="submitAddBillingPeriod()" ref="addBillingPeriodForm">
      <v-container grid-list-lg>
        <v-layout wrap>
          <dialog-header :title="'Add Billing Period'"></dialog-header>
          <v-flex xs12 sm8>
            <v-text-field
              label="Name"
              v-model="billingPeriod.name"
              :color="$store.state.global.pages.settings.color"
              :rules="nameRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-switch
              label="Open"
              v-model="billingPeriod.isOpen"
              :color="$store.state.global.pages.settings.color"
              :rules="isOpenRules"
            ></v-switch>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat color="grey darken-1" @click="close()">Close</v-btn>
        <v-btn flat color="green" :loading="loading" type="submit">Save</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import BillingPeriodService from '@/services/requests/billingPeriodService'
import Store from '@/store/computed/storeHelpers'

// MIXINS
import BillingPeriodValidation from './validation/billingPeriodValidation'

// COMPONENTS
import DialogHeader from '@/components/ui/dialogHeader'

export default {
  mixins: [BillingPeriodValidation],
  components: {
    DialogHeader,
  },
  data() {
    return {
      loading: false,
      billingPeriod: {
        name: null,
        isOpen: true,
        isActive: true,
      },
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    discard() {
      this.billingPeriod = {
        name: null,
        isOpen: true,
        isActive: true,
      }
      this.close()
    },
    submitAddBillingPeriod() {
      if (!this.$refs.addBillingPeriodForm.validate()) {
        return
      }
      this.save(this.billingPeriod)
    },
    save(payload) {
      this.loading = true
      BillingPeriodService.createBillingPeriod(payload)
        .then((result) => {
          this.handleSuccess(result)
        })
        .catch((err) => {
          this.handleError(err)
        })
    },
    handleSuccess(result) {
      const billingPeriod = result.data.result
      this.$store.commit('settings/addToArrayState', {
        prop: 'billingPeriods',
        value: billingPeriod,
      })
      this.snack({ text: 'Billing period added', color: 'green' })
      this.discard()
      this.loading = false
    },
    handleError(err) {
      this.snack({ text: err.response.data.message, color: 'red' })
      this.loading = false
    },
  },
}
</script>

<style>
</style>